<template>
	<div
		v-if="!hideTabsPanelIfOnlyOneTab || tabs.length > 1"
		class="ao-tabs d-flex justify-space-between"
	>
		<div
			v-for="tab in tabs"
			:key="tab.key"
			class="d-flex ao-tabs-item align-center flex-column justify-center pa-1"
			:class="{active:tab.key===modelValue}"
			:value="tab.key"
			@click="modelValue = $emit('update:modelValue', tab.key)"
		>
			<ao-icon :iconName="tab.icon" />
			<span class="ao-p1 text-capitalize text-center mt-1">
				{{ tab.titleTranslationKey ? $t(tab.titleTranslationKey) : tab.text }}
			</span>
		</div>
	</div>
	<v-card-text class="ao-tabs-content">
		<slot/>
	</v-card-text>
</template>

<script>
export default {
	name: 'AoTabs',

	props: {
		modelValue: {
			type: String,
			default: null,
		},
		tabs: {
			type: Array,
			default: null,
		},
		hideTabsPanelIfOnlyOneTab: {
			type: Boolean,
			default: true,
		},
	},
}
</script>

<style lang="scss">
.ao-tabs {
	width: 100%;
	&-content {
		width: 100%;
	}
	&-item{
		width: 100%;
		height:74px;
		max-height:66px;
		background:#E6EEF3;
		border-width: 1px;
		border-style: solid;
		border-color:#DEE6E8 ;
		margin-top: 8px;
		border-bottom: 0;
		cursor:pointer;
		transition: max-height 0.3 ease-out;
		transition:  margin-top 0.3s ease-out;
		color :rgb(var(--v-theme-textSecondary700));
		&.active{
			height:74px;
			max-height:74px;
			background:#FFFFFF;
			margin-top: 0px;
			border-radius: 8px 8px 0px 0px;
			color :rgb(var(--v-theme-primary));
		}
	}
}
</style>
